import { render, staticRenderFns } from "./ActivityPackagePeriodDetail.vue?vue&type=template&id=357be58c&scoped=true&"
import script from "./ActivityPackagePeriodDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityPackagePeriodDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPackagePeriodDetail.vue?vue&type=style&index=0&id=357be58c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357be58c",
  null
  
)

export default component.exports